module.exports = __webpack_public_path__ + "static/media/location-maps-letter-j-arrow-serr1.7935a7a8.png";